var exports = {
  "LA": "xf61da738--d8e0cf--iframe-container",
  "pU": "xf61da738--d8e0cf--iframe",
  "VN": "xf61da738--d8e0cf--close",
  "u1": "xf61da738--d8e0cf--spinner",
};

module.exports = exports;
